import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { IconName } from '../../icons-container/icons.type';

export type Color =
  | 'default'
  | 'primary'
  | 'optional'
  | 'secondary'
  | 'success'
  | 'overdue'
  | 'warning'
  | 'scale'
  | 'scale-reverse'
  | 'lead'
  | 'lead-reverse'
  | 'counter-default'
  | 'counter-distinction'
  | 'counter-notification'
  | 'counter-light'
  | 'counter-dark';

@Component({
  selector: 'rt-badge',
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': 'color',
  },
})
export class BadgeComponent {
  @Input() public color: Color;
  @Input() public iconName: IconName;
  @Input() public text: string | number;
}
